import {useQuery} from 'react-query';
import getStoreRedesignView from '.';

interface IGetStoreRedesignViewProps {
  store_guid?: string;
  onSuccessAfterGetStoreView?: (data: IStoreDetail) => void;
}

const useGetStoreRedesignView = ({
  store_guid,
  onSuccessAfterGetStoreView,
}: IGetStoreRedesignViewProps) => {
  const {data, isLoading} = useQuery(
    ['get-store-redesign-view'],
    () => getStoreRedesignView(store_guid),
    {
      enabled: store_guid ? true : false,
      onSuccess: data => {
        onSuccessAfterGetStoreView && onSuccessAfterGetStoreView(data);
      },
    },
  );

  return {storeData: data, storeDataIsLoading: isLoading};
};

export default useGetStoreRedesignView;
